export type SMSPlaceholderDefinition = {
  key: string;
  label: string;
  description: string;
  example?: string;
  recipient?: boolean;
};

export type SMSProviderDefinition = {
  id: string;
  label: string;
};

export type SMSTemplate = {
  id?: number;
  company_id?: number;
  name: string;
  body: string;
  active: boolean;
  created_at?: string;
  updated_at?: string;
};

export type SMSCompanySettings = {
  company_id?: number;
  provider: string;
  provider_token?: string;
  token_configured: boolean;
  sender?: string;
};

export type SendExcursionSMSRequest = {
  user_ids: number[];
  customer_ids: number[];
  template_id?: number;
  message?: string;
};

export type SendExcursionSMSResponse = {
  total: number;
  sent: number;
  skipped_no_phone: number;
  blacklisted?: number;
  invalid?: number;
  not_allowed?: number;
  flood?: number;
  moderated?: boolean;
};

export type ExcursionSMSMessageStatus =
  | "accepted"
  | "moderated"
  | "sent"
  | "delivered"
  | "not_sent"
  | "denied"
  | "undelivered"
  | "blacklisted"
  | "invalid"
  | "not_allowed"
  | "flood"
  | "no_phone"
  | "failed";

export type ExcursionSMSMessage = {
  id: number;
  excursion_id: number;
  recipient_kind: "user" | "customer";
  recipient_id: number;
  recipient_name: string;
  phone: string;
  template_id?: number;
  /** Empty for a free-text message. */
  template_name?: string;
  body: string;
  status: ExcursionSMSMessageStatus;
  status_details?: string;
  sent_by_name?: string;
  sent_at: string;
  status_checked_at?: string;
};

export type ExcursionSMSMessagesResponse = {
  messages: ExcursionSMSMessage[];
  total: number;
};

export type SendExcursionSMSOutcome =
  | { ok: true; result: SendExcursionSMSResponse }
  | { ok: false; error: string; code?: string };

/** Provider-wide failures: retrying other recipients would fail the same way. */
export const SMS_GLOBAL_ERROR_CODES = ["sms_insufficient_credits", "sms_provider_auth"] as const;
